export default __webpack_public_path__ + "static/media/logo.f5546de5.svg";